var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHyphenLogoMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 178.515,
    height: 28.771,
    viewBox: "0 0 178.515 28.771",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26436",
    "data-name": "Group 26436",
    transform: "translate(-858.013 -82.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34062",
    "data-name": "Path 34062",
    d: "M335.975,857.578h-5.421c0-4.14-1.2-7.284-3.553-9.345-4.692-4.1-12.648-3.081-12.728-3.071l-.745-5.37c.423-.059,10.437-1.385,17.012,4.335C334.147,847.264,335.975,851.789,335.975,857.578Z",
    transform: "translate(546.382 -746.361)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34063",
    "data-name": "Path 34063",
    d: "M462.624,832.669a24.386,24.386,0,0,1-3.075-.173l.731-5.371c.083.011,8.333,1.049,13.134-3.158a10.35,10.35,0,0,0,3.352-6.546H461.272V812h21.1v2.711c0,5.729-1.822,10.223-5.415,13.357C472.446,832,466.281,832.669,462.624,832.669Z",
    transform: "translate(463.278 -729.435)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_267",
    "data-name": "Rectangle 267",
    width: 5.421,
    height: 28.653,
    transform: "translate(876.936 82.564)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_268",
    "data-name": "Rectangle 268",
    width: 5.035,
    height: 28.771,
    transform: "translate(858.013 82.451)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34064",
    "data-name": "Path 34064",
    d: "M413,886",
    transform: "translate(488.614 -774.783)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34065",
    "data-name": "Path 34065",
    d: "M413,873",
    transform: "translate(488.614 -766.816)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34066",
    "data-name": "Path 34066",
    d: "M414.04,845.177",
    transform: "translate(487.977 -749.766)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34067",
    "data-name": "Path 34067",
    d: "M553.975,857.578h-5.421c0-4.14-1.2-7.284-3.553-9.345-4.692-4.1-12.649-3.082-12.728-3.071l-.745-5.37c.424-.059,10.435-1.385,17.013,4.335C552.147,847.263,553.975,851.789,553.975,857.578Z",
    transform: "translate(422.356 -746.361)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_269",
    "data-name": "Rectangle 269",
    width: 5.421,
    height: 28.653,
    transform: "translate(970.91 82.564)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_270",
    "data-name": "Rectangle 270",
    width: 5.754,
    height: 28.771,
    transform: "translate(982.97 82.451)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_271",
    "data-name": "Rectangle 271",
    width: 21.098,
    height: 5.275,
    transform: "translate(983.69 82.451)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_272",
    "data-name": "Rectangle 272",
    width: 5.916,
    height: 28.771,
    transform: "translate(921.691 82.451)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_273",
    "data-name": "Rectangle 273",
    width: 21.098,
    height: 5.035,
    transform: "translate(983.69 106.187)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_274",
    "data-name": "Rectangle 274",
    width: 5.035,
    height: 28.771,
    transform: "translate(951.971 82.451)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_275",
    "data-name": "Rectangle 275",
    width: 5.421,
    height: 28.653,
    transform: "translate(1031.107 82.564)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_276",
    "data-name": "Rectangle 276",
    width: 5.994,
    height: 28.771,
    transform: "translate(1011.333 82.451)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34068",
    "data-name": "Path 34068",
    d: "M629.04,841.177",
    transform: "translate(365.789 -747.315)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34069",
    "data-name": "Path 34069",
    d: "M605.421,852.78H600c0-11.013,12.653-14,19.344-14.04l.037,5.42a26.932,26.932,0,0,0-7.569,1.343C605.421,847.738,605.421,851.533,605.421,852.78Z",
    transform: "translate(383.585 -745.822)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34070",
    "data-name": "Path 34070",
    d: "M407.71,832.909h-5.421c0-6.16,1.925-11.456,5.566-15.315A17.59,17.59,0,0,1,420.763,812v5.421C412.194,817.421,407.71,825.212,407.71,832.909Z",
    transform: "translate(495.178 -729.435)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34071",
    "data-name": "Path 34071",
    d: "M389.818,826.011c-3.051-6.1-6.384-8.59-11.5-8.59V812c9.463,0,13.864,6.613,16.351,11.587Z",
    transform: "translate(509.869 -729.435)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    width: 5.421,
    height: 8.374,
    transform: "translate(897.443 102.843)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34072",
    "data-name": "Path 34072",
    d: "M685.134,840.653C670.483,840.653,665,816.861,665,812h5.421a42.684,42.684,0,0,0,3.81,13.275c2.125,4.543,5.741,9.957,10.9,9.957Z",
    transform: "translate(346.941 -729.435)",
    fill: "#ffffff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyphenLogoMain);
export default __webpack_public_path__ + "static/media/HyphenLogoMain.5ec8741389073e505dffbe0ee0901315.svg";
export { ForwardRef as ReactComponent };